/**
 * 默认情感图标
 */
export const DefaultIconMap = {
  primary: 'info-circle-s',
  secondary: 'info-circle-s',
  success: 'check-circle-s',
  warning: 'exclamation-circle-s',
  danger: 'exclamation-circle-s',
}
